import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import colors from "../../../assets/theme/colors";
import TopBarShell from "../../Common/TopBarShell";
import CareProfileBackButton from "../../UI/CareProfileBackButton";

const ChildProfileFlowPageShell = ({
  title,
  subtitle,
  onBack,
  children,
  footer = null,
  bottomNavigation = null,
  headerBadge = null,
  maxContentWidth = 960,
  navigationDisabled = false,
}) => {
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        bgcolor: colors.landing.pageBackground,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TopBarShell
        left={(
          <CareProfileBackButton
            onClick={onBack}
            disabled={navigationDisabled}
            ariaLabel="Go back"
          />
        )}
        center={(
          <Box sx={{ minWidth: 0, display: "flex", alignItems: "center", gap: 1.1 }}>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                noWrap
                sx={{
                  fontWeight: 500,
                  fontSize: "17px",
                  lineHeight: 1.2,
                  color: colors.landing.heroText,
                }}
              >
                {title}
              </Typography>
              {subtitle ? (
                <Typography
                  noWrap
                  sx={{
                    mt: 0.1,
                    fontWeight: 500,
                    fontSize: "0.75rem",
                    color: colors.semantic.ink2,
                  }}
                >
                  {subtitle}
                </Typography>
              ) : null}
            </Box>
            {headerBadge}
          </Box>
        )}
        right={<Box sx={{ width: 8, height: 8 }} />}
      />

      <Box
        component="main"
        sx={{
          flex: 1,
          px: { xs: 1.25, sm: 2.5, md: 3 },
          py: { xs: 1.5, sm: 2.2 },
          pb: footer && bottomNavigation
            ? {
                xs: "calc(166px + env(safe-area-inset-bottom))",
                sm: "calc(156px + env(safe-area-inset-bottom))",
              }
            : footer
            ? {
                xs: "calc(92px + env(safe-area-inset-bottom))",
                sm: "calc(86px + env(safe-area-inset-bottom))",
              }
            : bottomNavigation
              ? {
                  xs: "calc(88px + env(safe-area-inset-bottom))",
                  sm: "calc(82px + env(safe-area-inset-bottom))",
                }
              : { xs: 2.5, sm: 3.5 },
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: maxContentWidth, mx: "auto" }}>
          {children}
        </Box>
      </Box>

      {footer ? (
        <Box
          sx={{
            position: "fixed",
            bottom: bottomNavigation
              ? "calc(72px + env(safe-area-inset-bottom))"
              : 0,
            left: 0,
            right: 0,
            zIndex: 2,
            bgcolor: "rgba(255,255,255,0.96)",
            borderTop: `1px solid ${colors.landing.borderSoft}`,
            boxShadow: `0 -10px 24px ${colors.landing.shadowMedium}`,
            px: { xs: 1.25, sm: 2.5, md: 3 },
            pb: "calc(env(safe-area-inset-bottom) + 10px)",
            pt: 0.9,
          }}
        >
          <Box sx={{ width: "100%", maxWidth: maxContentWidth, mx: "auto" }}>
            {footer}
          </Box>
        </Box>
      ) : null}
      {bottomNavigation ? (
        <Box
          aria-disabled={navigationDisabled || undefined}
          sx={{
            pointerEvents: navigationDisabled ? "none" : "auto",
            opacity: navigationDisabled ? 0.62 : 1,
          }}
        >
          {bottomNavigation}
        </Box>
      ) : null}
    </Box>
  );
};

export default ChildProfileFlowPageShell;
